<template>
  <div v-loading="loading" class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          v-for="(item, $index) in tabList"
          :key="item.permissson"
          v-permissson="`${item.permissson}`"
          :class="['tabItem', active === $index ? 'active' : '']"
          @click="changeType($index)"
        >
          {{ item.name }}
        </span>
      </div>
    </div>
    <div class="opt">
      <BaseFilter
        :isActive="isActive"
        :width="466"
        @sendFilter="sendFilter"
        @reset="reset"
      >
        <div class="filter">
          <el-form ref="form" :model="filterList" label-width="70px">
            <el-form-item v-if="active === 0" label="客户">
              <el-select
                v-model="filterList.companyId"
                filterable
                clearable
                placeholder="请选择状态"
                style="width: 320px"
              >
                <el-option
                  v-for="item in companyDrapdown"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-else label="代理">
              <el-select
                v-model="filterList.supplierId"
                filterable
                clearable
                placeholder="请选择状态"
                style="width: 320px"
              >
                <el-option
                  v-for="item in supplierOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item v-if="active === 0" label="销售">
              <el-select
                v-model="filterList.saleId"
                filterable
                clearable
                placeholder="请选择销售"
                style="width: 320px"
              >
                <el-option
                  v-for="item in userOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <!-- 客户编码 -->
        </div>
      </BaseFilter>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :height="height"
        :tableData="{
          ...tableData,
          fileds
        }"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :pageSizes="[20, 30, 50, 100]"
        :loading="loading"
        :isPager="true"
        :isEmptyBorder="true"
        @handlePageChange="handlePageChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChange="sortChange"
      >
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <span
                  :v-permissson="newVerification"
                  class="opt-item"
                  @click="verification(row.scope)"
                >核销</span
                >
                <span
                  :v-permissson="newVerificationLog"
                  class="opt-item"
                  @click="verificationLog(row.scope)"
                >核销记录</span
                >
              </div>
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
      </BaseTable>
      <VerificationLogDrawer
        :drawer="drawer"
        :active="active"
        :rowData="rowData"
        @close="drawer = false"
      ></VerificationLogDrawer>
      <!-- <VerificationDialog :dialogVisible="dialogVisible" :rowData="rowData" @cancel="dialogVisible = false" @ok="dialogVisible = false; getList(pager)"></VerificationDialog> -->
      <VerificationAndWaterDrawer
        :drawer="drawer1"
        :rowData="rowData"
        :active="active"
        @close="drawer1 = false"
        @ok="
          drawer1 = false;
          getList(pager);
        "
      ></VerificationAndWaterDrawer>
    </div>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
import { companyAccountVerifyPages, supplierAccountVerifyPages } from '@/api/fee'
// import VerificationDialog from './components/VerificationDialog'
import VerificationLogDrawer from './components/VerificationLogDrawer'
import VerificationAndWaterDrawer from './components/VerificationAndWaterDrawer'
import { permissions } from '@/utils/common'
import { getSaleList, getSupplierDropDownList } from '@/api/system'
import { myMixins } from '@/mixins'
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
export default {
  name: 'Verification',
  components: {
    BaseTable,
    BaseFilter,
    // VerificationDialog,
    VerificationLogDrawer,
    VerificationAndWaterDrawer
  },
  mixins: [myMixins],
  data() {
    return {
      tableData: {
        fileds: [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true
          },
          {
            filed: 'companyName',
            label: '客户',
            width: ''
          },
          {
            filed: 'saleName',
            label: '销售员',
            width: ''
          },
          {
            filed: 'paymentAmount',
            label: '充值总金额',
            width: '',
            isSort: true,
            tip: true,
            tipContent: '取消核销不影响充值总金额'
          },
          {
            filed: 'receivedAmount',
            label: '到账金额',
            width: '',
            isSort: true,
            tip: true,
            tipContent: '取消核销不影响到账金额'
          },
          {
            filed: 'currentAmount',
            label: '当前余额',
            width: '',
            isSort: true
          },
          {
            filed: 'creditAmount',
            label: '信用额度',
            width: '',
            isSort: true
          },
          {
            filed: 'invoiceAmount',
            label: '账单总金额',
            width: '',
            isSort: true
          },
          {
            filed: 'unverifyConfirmAmount',
            label: '已确认金额',
            width: '',
            isSort: true
          },
          {
            filed: 'unverifyUnConfirmAmount',
            label: '未确认金额',
            width: '',
            isSort: true
          },
          {
            filed: 'verifedAmount',
            label: '已经核销金额',
            width: '',
            isSort: true
            // tip: true,
            // tipContent: `到账金额 > 账单总金额 - 未确认金额为账单总金额 - 未确认金额<br /> 到账金额 < 账单总金额 - 未确认金额为到账金额`
          },
          {
            filed: 'remainingVerifiableAmount',
            label: '剩余可核销金额',
            width: '150',
            isSort: true,
            tip: true,
            tipContent: '到账金额 - 已经核销金额'
          },
          {
            filed: 'unverifyInoviceAmountUnCk',
            label: '账单未核销金额',
            width: '150',
            isSort: true,
            tip: true,
            tipContent: '账单总金额 - 未确认金额 - 已经核销金额'
          },
          {
            filed: 'lastVerifyDate',
            label: '最后核销日期',
            width: '',
            formatter: (row) => {
              return row.lastVerifyDate
                ? dayjs(row.lastVerifyDate).format('YYYY-MM-DD')
                : ''
            }
          },
          {
            filed: 'operatorHanders',
            label: '操作负责人',
            width: ''
          },
          {
            filed: 'customerHanders',
            label: '客服负责人',
            width: ''
          }
        ],
        mutiCheck: true,
        columns: [],
        total: 0
      },
      loading: false,
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      height: 0,
      filterList: {
        companyId: '',
        supplierId: '',
        saleId: ''
      },
      isActive: false,
      companyOption: [],
      userOptions: [],
      orderObj: {},
      rowData: {},
      dialogVisible: false,
      selectionItem: [],
      drawer: false,
      drawer1: false,
      tabList: [
        { name: '客户', permissson: 'KH', type: 0 },
        { name: '代理', permissson: 'DL', type: 1 }
      ],
      active: 0,
      activeCode: '',
      supplierOptions: []
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown']),
    newVerification() {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const presentTab = menu.children.find((a) => a.code === this.activeCode)
      const code = presentTab?.children?.find((a) => a.nameCH === '核销')?.code
      return code || ''
    },
    newVerificationLog() {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const presentTab = menu.children.find((a) => a.code === this.activeCode)
      const code = presentTab?.children?.find((a) => a.nameCH === '核销记录')?.code
      return code || ''
    },
    fileds() {
      let fileds = [...this.tableData.fileds]
      if (this.active === 1) {
        fileds = [
          {
            filed: 'opt',
            label: '',
            width: '50px',
            isCustom: true
          },
          {
            filed: 'supplierName',
            label: '代理',
            width: ''
          },
          {
            filed: 'paymentAmount',
            label: '充值总金额',
            width: '',
            isSort: true,
            tip: true,
            tipContent: '取消核销不影响充值总金额'
          },
          // {
          //   filed: 'receivedAmount',
          //   label: '到账金额',
          //   width: '',
          //   isSort: true,
          //   tip: true,
          //   tipContent: '取消核销不影响到账金额'
          // },
          {
            filed: 'currentAmount',
            label: '未付总金额',
            width: '',
            isSort: true,
            tip: true,
            tipContent: '账单总金额 - 已经核销金额'
          },
          {
            filed: 'invoiceAmount',
            label: '账单总金额',
            width: '',
            isSort: true
          },
          {
            filed: 'verifedAmount',
            label: '已经核销金额',
            width: '',
            isSort: true,
            tip: true,
            tipContent: '到账金额 > 账单总金额为账单总金额, 到账金额 < 账单总金额为充值总金额'
          },
          {
            filed: 'remainingVerifiableAmount',
            label: '剩余可核销金额',
            width: '',
            isSort: true,
            tip: true,
            tipContent: '到账金额 - 已经核销金额'
          },
          // {
          //   filed: 'unverifyInoviceAmount',
          //   label: '剩余未核销金额',
          //   width: '',
          //   isSort: true,
          //   tip: true,
          //   tipContent: '充值总金额 - 已经核销金额'
          // },
          {
            filed: 'lastVerifyDate',
            label: '最后核销日期',
            width: '',
            formatter: (row) => {
              return row.lastVerifyDate
                ? dayjs(row.lastVerifyDate).format('YYYY-MM-DD')
                : ''
            }
          },
          {
            filed: 'lastVerifyName',
            label: '最后核销人',
            width: ''
          }
        ]
      }
      return fileds
    }
  },
  async created() {},
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
    const menuList = this.$store.getters.initRouter
    const menu = permissions(this.$route.meta.code, menuList)
    const codeList = ['KH', 'DL']
    const childrenCode = menu.children.map((a) => a.code)
    this.active = codeList.findIndex((a) => childrenCode.includes(a))
    this.activeCode = menu.children[0].code
    // this.getList(this.pager)
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
    this.getList(this.pager)
    this.getCommData()
  },
  methods: {
    getCommData() {
      getSupplierDropDownList({}).then((res) => {
        if (res.success) {
          res.data &&
            (this.supplierOptions = res.data.map((a) => {
              return {
                label: `${a.code}-${a.wbName}-${a.name}`,
                value: a.id
              }
            }))
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    handlePageChange(pager) {
      this.pager = {
        ...this.pager,
        ...pager
      }
      const params = {
        ...this.pager,
        ...pager
      }
      this.getList(params)
    },
    sortChange(orderObj) {
      if (orderObj.order) {
        this.orderObj = {
          sortField: orderObj.prop,
          sortBy: orderObj.order === 'asc' ? 0 : 1
        }
      } else {
        this.orderObj = {}
      }
      this.getList(this.pager)
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.orderObj,
            ...this.formatterFilter()
          }
        }
        let res
        if (!this.active) {
          res = await companyAccountVerifyPages(params)
        } else {
          res = await supplierAccountVerifyPages(params)
        }
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    initList() {
      const params = {
        ...this.pager
      }
      this.getList(params)
    },
    getUserList() {
      getSaleList().then((res) => {
        if (res.success) {
          const arr = []
          res.data.map((item) => {
            arr.push({
              value: item.id,
              label: item.nameCH
            })
          })
          this.userOptions = arr
        } else {
          this.$message.error(res.errorMessage)
        }
      })
    },
    sendFilter() {
      if (this.filterList.companyId !== '' || this.filterList.saleId !== '' || this.filterList.supplierId !== '') {
        this.isActive = true
      } else {
        this.isActive = false
      }
      this.pager = {
        pageIndex: 1,
        pageSize: 20
      }
      this.getList({
        pageIndex: 1,
        pageSize: 20
      })
    },
    reset() {
      this.filterList = {
        companyId: '',
        saleId: '',
        supplierId: ''
      }
      this.isActive = false
    },
    formatterFilter() {
      return {
        companyId: this.filterList.companyId
          ? this.filterList.companyId
          : undefined,
        supplierId: this.filterList.supplierId
          ? this.filterList.supplierId
          : undefined,
        saleId: this.filterList.saleId ? this.filterList.saleId : undefined
      }
    },
    verification(row) {
      this.rowData = row
      this.drawer1 = true
    },
    verificationLog(row) {
      this.rowData = row
      this.drawer = true
    },
    handleSelectionChange(item) {
      this.selectionItem = item
    },
    changeType(type) {
      this.active = type
      this.initList()
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color: rgb(18, 88, 188);
    }
    .opt {
      display: flex;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      & div {
        height: 30px;
        box-sizing: border-box;
        margin-right: 5px;
        border-radius: 4px;
        cursor: pointer;
      }
      .derive {
        width: 80px;
        border: 1px solid rgb(18, 88, 188);
        color: rgb(18, 88, 188);
      }
      .btn {
        width: 100px;
        background: rgb(18, 88, 188);
        border: 1px solid #eeeeee;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
  .opt {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .btn {
    width: 80px;
    height: 28px;
    background: #ffffff;
    color: rgb(18, 88, 188);
    border-radius: 4px;
    border: 1px solid rgb(18, 88, 188);
    opacity: 1;
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    margin-right: 10px;
  }
  .icon {
    font-size: 20px;
    vertical-align: text-top;
  }
  .data {
    width: 100%;
    height: calc(100% - 100px);
    & .fTable {
      border-top: 1px solid #ebeef5;
      box-sizing: border-box;
    }
  }
  .circle {
    width: 6px;
    height: 6px;
    opacity: 1;
    display: inline-block;
    border-radius: 50%;
    margin-right: 6px;
  }
  .tableopt {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      margin-right: 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
    }
  }
  .company {
    text-align: left;
  }
  .unAmount {
    color: rgb(18, 88, 188);
    img {
      cursor: pointer;
    }
  }
  .typebox {
    display: flex;
    justify-content: center;
    align-items: center;
    .bod {
      width: 6px;
      height: 6px;
      background: #35ba83;
      opacity: 1;
      border-radius: 50%;
      margin-right: 5px;
    }
    .red {
      width: 6px;
      height: 6px;
      background: #fe453d;
      opacity: 1;
    }
  }

  .table-opt:deep(.el-button) {
    padding: 0;
  }
}
</style>
